export const ERROR = 'ERROR';

export const DISMISS_ALERT = 'DISMISS_ALERT';

export const CLEAR_USER = 'CLEAR_USER';
export const CLEAR_NEW_USER = 'CLEAR_NEW_USER';


export const FULFILLED = '_FULFILLED';
export const REJECTED = '_REJECTED';
export const PENDING = '_PENDING';
export const GET_CLAIMS = 'GET_CLAIMS';

export const GET_COURTSLIST = 'GET_COURTSLIST';
export const GET_COURTTYPES = 'GET_COURTTYPES';
export const GET_USER = 'GET_USER';

export const SAVE_USER = 'SAVE_USER';
export const SAVE_NEW_USER = 'SAVE_NEW_USER';

//LOADER:
export const SHOW_SPINNER = 'SHOW_SPINNER';
export const HIDE_SPINNER = 'HIDE_SPINNER';

//Courses
export const GET_COURSE = 'GET_COURSE';
export const GET_COURSES = 'GET_COURSES';
export const DELETE_COURSES = 'DELETE_COURSES';
export const DELETE_SECTION = 'DELETE_SECTION';
export const DELETE_SECTIONS = 'DELETE_SECTIONS';
export const UPDATE_COURSE = 'UPDATE_COURSE';
export const SET_COURSE_FIELD = 'SET_COURSE_FIELD';
export const NEW_COURSE = 'NEW_COURSE';
export const NEW_SECTION = 'NEW_SECTION';
export const TOGGLE_COURSE_SECTION_VISABILITY = 'TOGGLE_COURSE_SECTION_VISABILITY';
export const ADD_COURSE_SECTIONS = 'ADD_COURSE_SECTIONS';
export const COPY_SECTION = 'COPY_SECTION';

//Static Data
export const GET_APP_VERSION = 'GET_APP_VERSION';
export const GET_PROGRAMDOCUMENTTYPES = 'GET_PROGRAMDOCUMENTTYPES';
export const GET_PERSONDOCUMENTTYPES = 'GET_PERSONDOCUMENTTYPES';
export const GET_TRAININGDOCUMENTTYPES = 'GET_TRAININGDOCUMENTTYPES';
export const GET_PERSONNEL_TYPES = 'GET_PERSONNEL_TYPES';
export const GET_DISCIPLINES = 'GET_DISCIPLINES';
export const GET_ADDRESSTYPES = 'GET_ADDRESSTYPES';
export const GET_JOURNALTYPES = 'GET_JOURNALTYPES';
export const GET_JOURNAL_STATUS_TYPES = 'GET_JOURNAL_STATUS_TYPES';
export const GET_JOURNAL_ROLE_TYPES = 'GET_JOURNAL_ROLE_TYPES';
export const GET_PERSONTYPES = 'GET_PERSONTYPES';
export const GET_COMMITTEEASSIGNMENTS = 'GET_COMMITTEEASSIGNMENTS';
export const GET_TRAINING_LOCATION_TYPES = 'GET_TRAINING_LOCATION_TYPES';
export const GET_EVENT_TYPES = 'GET_EVENT_TYPES';
export const UPDATE_EVENT_TYPE = 'UPDATE_EVENT_TYPE'
export const GET_TIME_ZONES = 'GET_TIME_ZONES';
export const UPDATE_TIME_ZONE = 'UPDATE_TIME_ZONE';
export const GET_COUNTIES = 'GET_COUNTIES';
export const GET_CITIES = 'GET_CITIES';

//Dashboard
export const DASHBOARD_MODULE_LOADED = 'DASHBOARD_MODULE_LOADED';

//Program 
export const ADD_PROGRAM_PHONE = 'ADD_PROGRAM_PHONE';
export const DELETE_PROGRAM = 'DELETE_PROGRAM';
export const GET_PROGRAM = 'GET_PROGRAM';
export const GET_PROGRAMS = 'GET_PROGRAMS';
export const SET_LOCATION = 'SET_LOCATION';
export const NEW_PROGRAM = 'NEW_PROGRAM';
export const SET_PROGRAM_FIELD = 'SET_PROGRAM_FIELD';
export const SET_PROGRAM_ADDRESS_FIELD = 'SET_PROGRAM_ADDRESS_FIELD';
export const SET_PROGRAM_PHONE_FIELD = 'SET_PROGRAM_PHONE_FIELD';
export const UPDATE_PROGRAM = 'UPDATE_PROGRAM';
export const CLEAR_PROGRAM_DATA = 'CLEAR_PROGRAM_DATA'; 
export const ADD_PROGRAM_POINTOFCONTACT = 'ADD_PROGRAM_POINTOFCONTACT';
export const ADD_UPDATE_PROGRAM_JOUNALENTRY = 'ADD_UPDATE_PROGRAM_JOUNALENTRY';
export const GET_PROGRAM_JOURNAL = 'GET_PROGRAM_JOURNAL';
export const DELETE_PROGRAM_JOUNALENTRIES = 'DELETE_PROGRAM_JOUNALENTRIES';
export const GET_PROGRAM_TRAININGS = 'GET_PROGRAM_TRAININGS';

//Pick Lists
export const GET_PROGRAM_PICKLIST = 'GET_PROGRAM_PICKLIST';
export const GET_TRAININGTYPES_PICKLIST = 'GET_TRAININGTYPES_PICKLIST';

//Program Documents
export const TOGGLE_CONTACT_PHONE_IS_VALID = 'TOGGLE_CONTACT_PHONE_IS_VALID';
export const TOGGLE_CONTACT_NAME_IS_VALID = 'TOGGLE_CONTACT_NAME_IS_VALID';
export const ADD_PROGRAM_DOCUMENT = 'ADD_PROGRAM_DOCUMENT';
export const DOWNLOAD_PROGRAM_DOCUMENT = 'DOWNLOAD_PROGRAM_DOCUMENT';
export const GET_PROGRAM_DOCUMENTS = 'GET_PROGRAM_DOCUMENTS';
export const DELETE_PROGRAM_DOCUMENTS = 'DELETE_PROGRAM_DOCUMENTS';

export const MAKE_PRIMARY_CONTACT = 'MAKE_PRIMARY_CONTACT';
export const ADD_PROGRAM_CONTACT = 'ADD_PROGRAM_CONTACT';
export const REMOVE_PROGRAM_CONTACTS = 'REMOVE_PROGRAM_CONTACTS';
export const GET_PROGRAM_CONTACTS = 'GET_PROGRAM_CONTACTS';
export const GET_PROGRAM_GRANTS = 'GET_PROGRAM_GRANTS';
export const ADD_PROGRAM_GRANTS = 'ADD_PROGRAM_GRANTS';
export const SEARCH_GRANTS = 'SEARCH_GRANTS';
export const SET_SHOW_CASES = 'SET_SHOW_CASES';

//Grants
export const GET_GRANT = 'GET_GRANT';
export const GET_GRANTS = 'GET_GRANTS';
export const DELETE_GRANT = 'DELETE_GRANT';
export const UPDATE_GRANT = 'UPDATE_GRANT';
export const SET_GRANT_FIELD = 'SET_GRANT_FIELD';
export const NEW_GRANT = 'NEW_GRANT'; 

//Projects
export const GET_PROJECT = 'GET_PROJECT';
export const GET_PROJECTS = 'GET_PROJECTS';
export const DELETE_PROJECT = 'DELETE_PROJECT';
export const UPDATE_PROJECT = 'UPDATE_PROJECT';
export const SET_PROJECT_FIELD = 'SET_PROJECT_FIELD';
export const NEW_PROJECT = 'NEW_PROJECT';

//TrainingTypes
export const GET_TRAINING_TYPE = 'GET_TRAINING_TYPE';
export const GET_TRAINING_TYPES = 'GET_TRAINING_TYPES';
export const DELETE_TRAINING_TYPE = 'DELETE_TRAINING_TYPE';
export const UPDATE_TRAINING_TYPE = 'UPDATE_TRAINING_TYPE';
export const UPDATE_TRAINING_TYPE_NAME = 'UPDATE_TRAINING_TYPE_NAME';
export const UPDATE_TRAINING_TYPE_DESCRIPTION = 'UPDATE_TRAINING_TYPE_DESCRIPTION';
export const NEW_TRAINING_TYPE = 'NEW_TRAINING_TYPE';
export const SET_TRAINING_TYPE_FIELD = 'SET_TRAINING_TYPE_FIELD';

//Sessions
export const UPDATE_SESSION = 'UPDATE_SESSION';
export const SAVE_SESSION = 'SAVE_SESSION';
export const NEW_SESSION = 'NEW_SESSION';
export const TOGGLE_SESSIONS_SESSION_ISACTIVE = 'TOGGLE_SESSIONS_SESSION_ISACTIVE';
export const DELETE_SESSION = 'DELETE_SESSION';
export const GET_SESSIONS = 'GET_SESSIONS';
export const GET_SESSION = 'GET_SESSION';

//Jurisdictions
export const UPDATE_JURISDICTION_NAME = 'UPDATE_JURISDICTION_NAME';
export const UPDATE_JURISDICTION_STATE = 'UPDATE_JURISDICTION_STATE';
export const UPDATE_JURISDICTION_CITY = 'UPDATE_JURISDICTION_CITY';
export const UPDATE_JURISDICTION = 'UPDATE_JURISDICTION';
export const SAVE_JURISDICTION = 'SAVE_JURISDICTION';
export const NEW_JURISDICTION = 'NEW_JURISDICTION';
export const TOGGLE_JURISDICTION_ISACTIVE = 'TOGGLE_JURISDICTION_ISACTIVE';
export const DELETE_JURISDICTION = 'DELETE_JURISDICTION';
export const GET_JURISDICTIONS = 'GET_JURISDICTIONS';
export const GET_JURISDICTION = 'GET_JURISDICTION';

//Users
export const GET_USERS = 'GET_USERS';
export const CLEAR_USERS = 'CLEAR_USERS';
export const USER_MODULE_LOADED = 'USER_MODULE_LOADED';
export const UPDATE_USER_PERSON_PHOTO = 'UPDATE_USER_PERSON_PHOTO';
export const UPDATE_USER_PERSON_BIO = 'UPDATE_USER_PERSON_BIO';
export const UPDATE_USER_CONTEXT = 'UPDATE_USER_CONTEXT';
export const REMOVE_USER_CLAIM = 'REMOVE_USER_CLAIM';
export const UPDATE_USER_ROLE = 'UPDATE_USER_ROLE';
export const REMOVE_USER_PERSON_COURT = 'REMOVE_USER_PERSON_COURT';
export const ADD_USER_CLAIM = 'ADD_USER_CLAIM';
export const ADD_USER_PERSON_COURT = 'ADD_USER_PERSON_COURT';
export const NEW_USER = 'NEW_USER';
export const ADD_USER_COURTTYPE = 'ADD_USER_COURTTYPE';
export const REMOVE_USER_COURTTYPE = 'REMOVE_USER_COURTTYPE';
export const ADD_USER_ROLE = 'ADD_USER_ROLE';
export const REMOVE_USER_ROLE = 'REMOVE_USER_ROLE';
export const ADD_USER_DISCIPLINE = 'ADD_USER_DISCIPLINE';
export const REMOVE_USER_DISCIPLINE = 'REMOVE_USER_DISCIPLINE';
export const ADD_PERSON_DOCUMENT = 'ADD_PERSON_DOCUMENT';
export const DELETE_PERSON_DOCUMENTS = 'DELETE_PERSON_DOCUMENTS';
export const CLEAR_EDIT_CONTACT_DETAILS = 'CLEAR_EDIT_CONTACT_DETAILS';
export const GET_EDIT_CONTACT_DETAILS = 'GET_EDIT_CONTACT_DETAILS'
export const FROM_ADD_BUTTON = 'FROM_ADD_BUTTON';
export const GET_PERSON_DOCUMENTS = 'GET_PERSON_DOCUMENTS';
export const ADD_UPDATE_PERSON_JOUNALENTRY = 'ADD_UPDATE_PERSON_JOUNALENTRY';
export const GET_PERSON_JOURNAL = 'GET_PERSON_JOURNAL';
export const DELETE_PERSON_JOUNALENTRIES = 'DELETE_PERSON_JOUNALENTRIES';
export const SET_USER_ACTIVESTATUS = 'SET_USER_ACTIVESTATUS';
export const UPDATE_PERSON_ACTIVESTARTDATE = 'UPDATE_PERSON_ACTIVESTARTDATE';
export const UPDATE_PERSON_ACTIVEENDDATE = 'UPDATE_PERSON_ACTIVEENDDATE';
export const GET_PERSON_PHONES = 'GET_PERSON_PHONES';
export const GET_PERSON_TRAININGS = 'GET_PERSON_TRAININGS';
export const SAVE_PERSON_PHONES = 'SAVE_PERSON_PHONES';
export const DELETE_PERSON_PHONES = 'DELETE_PERSON_PHONES';
export const GET_PERSON_ADDRESSES = 'GET_PERSON_ADDRESSES';
export const SAVE_PERSON_ADDRESS = 'SAVE_PERSON_ADDRESS';
export const DELETE_PERSON_ADDRESSES = 'DELETE_PERSON_ADDRESSES';
export const GET_PERSON_EMAILS = 'GET_PERSON_EMAILS';
export const SAVE_PERSON_EMAILS = 'SAVE_PERSON_EMAILS';
export const DELETE_PERSON_EMAILS = 'DELETE_PERSON_EMAILS';
export const SAVE_USER_CLAIMS = 'SAVE_USER_CLAIMS';
export const SAVE_USER_ROLES = 'SAVE_USER_ROLES';
export const UPDATE_USER_PASSWORD = 'UPDATE_USER_PASSWORD';
export const TOGGLE_PASSWORD_CHANGE_MODAL = 'TOGGLE_PASSWORD_CHANGE_MODAL';
export const TOGGLE_NEW_USER_MODAL = 'TOGGLE_NEW_USER_MODAL';
export const DELETE_USERS = 'DELETE_USERS';

//Training
export const GET_TRAINING = 'GET_TRAINING';
export const GET_TRAININGS = 'GET_TRAININGS';
export const GET_TRAININGS_POCS = 'GET_TRAININGS_POCS';
export const UPDATE_TRAININGS_SELECTED_PROGRAMS = 'UPDATE_TRAININGS_SELECTED_PROGRAMS';
export const UPDATE_TRAININGS_SELECTED_TRAININGTYPES = 'UPDATE_TRAININGS_SELECTED_TRAININGTYPES';
export const DELETE_TRAINING = 'DELETE_TRAINING';
export const UPDATE_TRAINING = 'UPDATE_TRAINING';
export const SET_TRAINING_FIELD = 'SET_TRAINING_FIELD';
export const SET_TRAINING_LOCATION = 'SET_TRAINING_LOCATION';
export const SET_TRAINING_LOCATION_FIELD = 'SET_TRAINING_LOCATION_FIELD';
export const NEW_TRAINING = 'NEW_TRAINING';
export const ADD_TRAINING_PERSONNEL = 'ADD_TRAINING_PERSONNEL';
export const DELETE_TRAINING_PERSONNEL = 'DELETE_TRAINING_PERSONNEL';
export const ADD_TRAINING_COURSES = 'ADD_TRAINING_COURSES';
export const DELETE_TRAINING_COURSES = 'DELETE_TRAINING_COURSES';
export const UPDATE_TRAINING_PROGRAMS = 'UPDATE_TRAINING_PROGRAMS';
export const GET_TRAINING_CONTACTS = 'GET_TRAINING_CONTACTS';
export const GET_TRAINING_FACULTY = 'GET_TRAINING_FACULTY';
export const ADD_TRAINING_FACULTY = 'ADD_TRAINING_FACULTY';
export const DELETE_TRAINING_FACULTY = 'DELETE_TRAINING_FACULTY';
export const GET_TRAINING_CURRICULUM = 'GET_TRAINING_CURRICULUM';
export const ADD_TRAINING_CURRICULUM = 'ADD_TRAINING_CURRICULUM';
export const DELETE_TRAINING_CURRICULUM = 'DELETE_TRAINING_CURRICULUM';
export const ADD_COURSE_FACULTY = 'ADD_COURSE_FACULTY';
export const REMOVE_COURSE_FACULTY = 'REMOVE_COURSE_FACULTY';
export const ADD_TRAINING_CONTACT = 'ADD_TRAINING_CONTACT';
export const DELETE_TRAINING_CONTACT = 'DELETE_TRAINING_CONTACT';

//Training Documents
export const ADD_TRAINING_DOCUMENT = 'ADD_TRAINING_DOCUMENT';
export const DELETE_TRAINING_DOCUMENT = 'DELETE_TRAINING_DOCUMENT';
export const GET_TRAINING_DOCUMENTS = 'GET_TRAINING_DOCUMENTS';

//Training Journal
export const ADD_UPDATE_TRAINING_JOUNALENTRY = 'ADD_UPDATE_TRAINING_JOUNALENTRY';
export const GET_TRAINING_JOURNAL = 'GET_TRAINING_JOURNAL';
export const DELETE_TRAINING_JOUNALENTRIES = 'DELETE_TRAINING_JOUNALENTRIES';

//Training Programs
export const ADD_TRAINING_PROGRAMS = 'ADD_TRAINING_PROGRAMS';
export const DELETE_TRAINING_PROGRAMS = 'DELETE_TRAINING_PROGRAMS';
export const GET_TRAINING_PROGRAMS = 'GET_TRAINING_PROGRAMS';
export const ADD_PROGRAM_FROM_TRAINING = 'ADD_PROGRAM_FROM_TRAINING'

//Contacts
export const TOGGLE_PERSON_CONTACT_NAME_IS_VALID = 'TOGGLE_PERSON_CONTACT_NAME_IS_VALID';
export const GET_CONTACTS = 'GET_CONTACTS';
export const TOGGLE_CONTACTS_FLIP_STATE = 'TOGGLE_CONTACTS_FLIP_STATE';
export const NEW_CONTACT = 'NEW_CONTACT';
export const CLEAR_CONTACTS = 'CLEAR_CONTACTS';
export const GET_DAILYRATES_MIN_MAX = 'GET_DAILYRATES_MIN_MAX';

//Search
export const SEARCH_COURSES = 'SEARCH_COURSES';
export const CLEAR_SEARCHED_COURSES = 'CLEAR_SEARCHED_COURSES';
export const SEARCH_PERSONS = 'SEARCH_PERSONS';
export const CLEAR_SEARCHED_PERSONS = 'CLEAR_SEARCHED_PERSONS'
export const SEARCH_PROGRAMS = 'SEARCH_PROGRAMS';
export const CLEAR_TRAINING_CONTACTS_SEARCH = 'CLEAR_TRAINING_CONTACTS_SEARCH';
export const CLEAR_CONTACT_SEARCH_CRITERIA = 'CLEAR_CONTACT_SEARCH_CRITERIA';
export const CLEAR_CONTACT_SEARCH_ADVANCED_CRITERIA = 'CLEAR_CONTACT_SEARCH_ADVANCED_CRITERIA';
export const CLEAR_SEARCH_RESULTS = 'CLEAR_SEARCH_RESULTS';
export const SET_CONTACT_ADVANCED_SEARCH_CRITERIA = 'SET_CONTACT_ADVANCED_SEARCH_CRITERIA';
export const SET_CONTACT_SEARCH_CRITERIA = 'SET_CONTACT_SEARCH_CRITERIA';

//Person
export const CLEAR_PERSON = 'CLEAR_PERSON';
export const UPDATE_RATE_FIELD = 'UPDATE_RATE_FIELD'
export const GET_PERSON = 'GET_PERSON';
export const UPDATE_PERSON = 'UPDATE_PERSON';
export const SAVE_PERSON = 'SAVE_PERSON';
export const ADD_PERSON_DISCIPLINE = 'ADD_PERSON_DISCIPLINE';
export const REMOVE_PERSON_DISCIPLINE = 'REMOVE_PERSON_DISCIPLINE';
export const ADD_PERSON_COURTTYPE = 'ADD_PERSON_COURTTYPE';
export const REMOVE_PERSON_COURTTYPE = 'REMOVE_PERSON_COURTTYPE';
export const ADD_PERSON_COMMITTEEASSIGNMENT = 'ADD_PERSON_COMMITTEEASSIGNMENT';
export const REMOVE_PERSON_COMMITTEEASSIGNMENT = 'REMOVE_PERSON_COMMITTEEASSIGNMENT';
export const UPDATE_PERSON_TYPE = 'UPDATE_PERSON_TYPE';

//Faculty
export const SEARCH_FACULTY = 'SEARCH_FACULTY'
